<template>
  <div class="join">
    <el-dialog width="500px" title="编辑客户" :visible.sync="showEditMember" :before-close="handleCloseEdit">
      <edit-customer v-if="showEditMember" :memberInfo='memberInfo' :id="id"></edit-customer>
    </el-dialog>
    <el-dialog width="500px" title="重新绑定" :visible.sync="showBind"  :before-close="handleClose">
       <el-form ref="form" label-width="120px">
         <el-form-item label="运维人员姓名">
           <el-autocomplete
             class="drug-input"
             v-model="saleName"
             :fetch-suggestions="querySearch"
             placeholder="请输入运维人员"
             :trigger-on-focus="false"
             @select="handleSelect"
           ></el-autocomplete>
         </el-form-item>
         <el-form-item>
           <el-button type="primary" @click="reBind">确定</el-button>
           <el-button @click="cancle">取消</el-button>
         </el-form-item>
       </el-form>
    </el-dialog>
    <div class="title"><img src="../assets/circle.png">
       <b>客户列表</b>
        <el-button type="primary" size="medium" class="reback" @click="reback">返回</el-button>
        <el-button type="primary" size="medium" class="reBind" @click="reBindDevice">重新绑定</el-button>
    </div>
    <div class="joinList">
      <table class="activeTable" cellspacing="0" cellpadding="0">
        <tr><th width="4%"><input type="checkbox" v-model="checked" @change="checkAll"></th><th width="8%">小区+楼号+姓名</th><th width="8%">手机号</th><th width="15%">地址</th><th width="8%">设备数量</th><th width="8%">操作</th></tr>
        <tr v-for="(item,index) in joinList" :key="item.id">
          <td align="center"><input v-model="selectCustomer" type="checkbox" :value="item.id"></td>
          <td align="center">{{item.trueName}}</td>
           <td align="center">{{item.phone}}</td>
          <td align="center"><span :title="item.address">{{item.address|cutstr(20)}}</span></td>
          <td align="center">{{item.count}}</td>
          <td align="center" class="options"><span @click="editCustomer(item)">编辑</span><span @click="deleteCustomer(item.id)">删除</span></td>
        </tr>
      </table>
      <div class="nodata" v-if="showNodata"><img src="../assets/no_data.png"><p>暂无数据</p></div>
    </div>
    <div class="page" v-if="!showNodata"><page :total='total' :currentPage='cur' :pageSize='pageSize' @pageNum="getPage"></page></div>
    <loading v-if="showLoading"></loading>
  </div>
</template>

<script>
import Pinyin from 'pinyin-match'
import {deleteCustomer,getCustomerList,getOperatorList,changeCustomerOperator} from '@/api/api'
import bus from '@/bus'
import Page from '@/components/Page'
import {formatDate} from '@/api/common'
import EditType from '@/components/EditType'
import TimeSetting from '@/components/TimeSetting'
import EditCustomer from '@/components/EditCustomer'
import Loading from '@/components/Loading'
export default {
  name: 'device',
  data () {
    return {
      selectCustomer:[],
      joinList:[],
      deviceIds:[],
      memberInfo:{},
      keyword:'',
      showNodata:false,
      showTime:false,
      showBind:false,
      showEditMember:false,
      showLoading:false,
      timeList:[],
      checked:false,
      selectDevice:[],  //需要重新绑定的设备
      selectOperator:'', //旧运维人员ID
      saleId:'',         //新运维人员ID
      saleName:'',       //新运维人员姓名
      state:'Y',
      pageSize: 10, //每页几条
      cur: 1,//当前页码
      total:0 ,//总条数
      id:'',
      opratorList:[],
      saleNames:[],
      index:'',
    }
  },
  mounted(){
    var id=this.$route.query.id
    this.id=id
    bus.$off('closeEditMember')
    bus.$on('closeEditMember',res=>{
      this.showEditMember=false
      this.getData()
    })
    this.getData()
  },
  methods:{
    editCustomer(item){
       this.showEditMember=true
       this.memberInfo=item
    },
    deleteCustomer(id){
        this.$confirm('是否删除该客户?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var data=JSON.stringify({
            usrId:id
          })
          deleteCustomer(data).then(res=>{
             if(res.data.state==200){
               if(res.data.code){
                 this.$message({
                    message:res.data.code,
                    type: 'warning'
                 })
               }else{
                 this.getData()
                 this.$message({
                    message: '删除成功',
                    type: 'success'
                 })
               }

             }else{
               this.$message({
                  message: '操作失败',
                  type: 'warning'
               })
             }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    handleClose(){
      this.saleName=''
      this.saleId=''
      this.showBind=false
    },
    handleCloseEdit(){
      this.showEditMember=false
    },
    reBind(){
       if(this.saleId!=''){
          let data=JSON.stringify({
            "devOpsId":this.saleId,
            "usrId":this.selectCustomer.join(','),
          })
          changeCustomerOperator(data).then(res=>{
            if(res.data.state==200){
              this.selectCustomer=[]
              this.saleName=''
              this.showBind=false
              this.getData()
              this.$message({
                 message: '操作成功',
                 type: 'success'
              })
            }else{
              this.$message({
                 message: '操作失败',
                 type: 'warning'
              })
            }
          })
       }else{
         this.$message({
            message: '请选择新运维',
            type: 'warning'
         })
       }
    },
    reBindDevice(){
      if(this.selectCustomer==''){
        this.$message({
           message: '请选择客户',
           type: 'warning'
        })
      }else{
        this.showBind=true
      }

    },
    checkAll(){
      if(!this.checked){
        this.selectCustomer=[]
      }else{
        this.selectCustomer=this.deviceIds
      }
    },
    cancle(){
      this.showBind=false
      this.saleName=''
      this.saleId=''
    },
    querySearch(queryString, cb) {
          var drugNames = this.saleNames;
          var results = queryString ? drugNames.filter(this.createFilter(queryString)) : restaurants;
          // 调用 callback 返回搜索的会员
          cb(results);
    },
    createFilter(queryString) {
          return (restaurant) => {
            return (Pinyin.match(restaurant.value.toLowerCase(), queryString.toLowerCase())) ;
          };
    },
    handleSelect(item){
      console.log(item)
      this.saleName=item.value
      this.saleId=item.id
    },
    reback(){
      this.$router.back()
    },
    viewTime(index){
      let record=this.joinList[index]
      this.deviceInfo=record
      this.showTime=true
    },
    getData(){
         var data=JSON.stringify({
           "devOpsId":this.id,
           	"pageSize": this.pageSize,
           	"currentPage": this.cur
         })
      this.showLoading=true
      getCustomerList(data).then(res=>{
        this.showLoading=false
        if(res.data.state==200){
          const {data}=res.data
          if(data==''||data==null){
            this.showNodata=true
          }else{
            this.showNodata=false
          }
          this.total=res.data.totalCount
          this.joinList=data
          var records=[]
          this.joinList.forEach((item,index)=>{
            records.push(item.id)
          })
          this.deviceIds=records
          var data=JSON.stringify({})
          getOperatorList(data).then(res=>{
            if(res.data.state==200){
              const {data}=res.data
              data.forEach((item,index)=>{
                this.joinList.forEach((item1,index1)=>{
                  if(item1.devopsIds==item.id){
                    item1.trueNme=item.trueName
                  }
                })
              })
              this.$forceUpdate()
              this.saleNames=data.map(item=>{
                let trueName=item.trueName+'/'+item.phone
                return {value:trueName,id:item.id}
              })
            }
          })
        }
      }).catch(err=>{
        this.showLoading=false
      })
    },
    getPage(data){
      this.cur=data
    }
  },
  filters:{
    getTime(time) {
     var date = new Date(time);
     return formatDate(date, 'yyyy-MM-dd h:m:s').slice(0,16);
    },
    cutstr(val,len){
      if(val&&val.length>len){
        return val.slice(0,len)+'...'
      }else{
        return val
      }
    },
    cutserial(val){
       var len=val.toString().length
       console.log(len)
        if(len==1){
          return '00'+val
        }
        if(len==2){
          return '0'+val
        }
    },
    changeState(val){
      return val=='Y'?'在线':'离线'
    },
    changeTime(val){
      return parseFloat(val)/60
    }
  },
  watch:{
    cur(val){
      this.getData('')
    },
    selectDevice() {
    			if (this.selectDevice.length == this.deviceIds.length) {
    				this.checked = true
    			} else {
    				this.checked = false
    			}
    		}
  },
  components:{
    Page,
    EditType,
    EditCustomer,
    TimeSetting,
    Loading
  },
  // beforeRouteEnter(to,from,next) {
  //   var that=this
  //   var manager=localStorage.getItem('manager')
  //   if(manager=='M'){
  //     next()
  //   }else{
  //      alert('您没有访问权限')
  //      next('/login')
  //   }
  // }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
   .searchDiv {height:50px;line-height:50px;}
   .el-input {width:250px;margin-right:10px;}
   .joinList {height:500px;margin-top:20px;}
   .activeTable {width:100%;margin-top:5px;}
   .activeTable tr {height:40px;line-height:45px;}
   .activeTable tr input {width:16px;height:16px;position:relative;top:2px;}
   .activeTable tr th {font-weight: 100;background:#f6f6f6;}
   .activeTable tr td {border-bottom: #eee 1px solid;}
   .page {height:50px;}
   .searchDivLeft {width:400px;float: left;}
   .searchDivRight {width: 300px;text-align: right;float: right;}
   .options span {color:#357af1;margin-left:10px;margin-right:10px;cursor: pointer;}
   .addBn {float: right;}
   .view {color:#357af1;cursor: pointer;}
   .timeTable {width:100%;position: relative;top:-10px;border-collapse: collapse;}
   .timeTable th {height:35px;line-height:35px;background:#f4f4f4;}
   .timeTable td {height:30px;line-height:30px;text-align:center;border:#f4f4f4 1px solid;}
   .selectSate {width:100px;margin-left:20px}
   .reBind {float: right;}
   .reback {margin-left:15px;float: right;}
</style>



// WEBPACK FOOTER //
// src/views/OperatorCustomer.vue